import { render } from "./Index.vue?vue&type=template&id=9ee4f966&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=9ee4f966&scoped=true&lang=scss"

import exportComponent from "/usr/share/nginx/production/goodedition/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ee4f966"]])

export default __exports__